<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">
  
  <!-- Éditeur du site -->
  <section class="page-section">
    <div class="legal-section">
      <h2><i class="pi pi-building"></i> Éditeur du site</h2>
      
      <div class="legal-info">
        <h3>Raison sociale</h3>
        <p><strong>Brokins</strong><br>
        Cabinet de courtage en assurance</p>
        
        <h3>Forme juridique</h3>
        <p>Société par Actions Simplifiée (SAS)</p>
        
        <h3>Siège social</h3>
        <p>
          79 rue de Rennes<br>
          75006 Paris<br>
          France
        </p>
        
        <h3>Contact</h3>
        <p>
          <strong>Téléphone :</strong> 01 43 27 12 43<br>
          <strong>Email :</strong> contact&#64;brokins.fr
        </p>
      </div>
    </div>
  </section>


  <!-- Autorité de contrôle -->
  <section class="page-section">
    <div class="info-box">
      <h2><i class="pi pi-eye"></i> Autorité de contrôle</h2>
      
      <p>Notre activité de courtage en assurance est contrôlée par :</p>
      
      <div class="authority-info">
        <h3>Autorité de Contrôle Prudentiel et de Résolution (ACPR)</h3>
        <p>
          4 Place de Budapest<br>
          CS 92459<br>
          75436 Paris Cedex 09<br>
          <strong>Site web :</strong> <a href="https://acpr.banque-france.fr" target="_blank" rel="noopener">acpr.banque-france.fr</a>
        </p>
      </div>
    </div>
  </section>


  <!-- Propriété intellectuelle -->
  <section class="page-section">
    <h2><i class="pi pi-copyright"></i> Propriété intellectuelle</h2>
    
    <p>L'ensemble du contenu de ce site (textes, images, logos, vidéos, graphismes, etc.) est la propriété exclusive de <strong>Brokins</strong> ou de ses partenaires.</p>
    
    <div class="ip-rules">
      <div class="rule-item">
        <i class="pi pi-ban"></i>
        <div>
          <h4>Reproduction interdite</h4>
          <p>Toute reproduction, représentation, modification ou exploitation du contenu sans autorisation préalable écrite est strictement interdite.</p>
        </div>
      </div>
      
      <div class="rule-item">
        <i class="pi pi-trademark"></i>
        <div>
          <h4>Marques déposées</h4>
          <p>Les marques, logos et signes distinctifs reproduits sur ce site sont des marques déposées et protégées.</p>
        </div>
      </div>
      
      <div class="rule-item">
        <i class="pi pi-link"></i>
        <div>
          <h4>Liens hypertextes</h4>
          <p>La création de liens hypertextes vers ce site nécessite l'autorisation préalable de Brokins.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Responsabilité -->
  <section class="page-section">
    <h2><i class="pi pi-exclamation-triangle"></i> Limitation de responsabilité</h2>
    
    <div class="responsibility-info">
      <p>Brokins s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois :</p>
      
      <ul>
        <li>Les informations sont fournies à titre indicatif et ne constituent pas un engagement contractuel</li>
        <li>Brokins ne garantit pas l'absence d'erreurs, d'omissions ou d'interruptions de service</li>
        <li>L'utilisateur est seul responsable de l'utilisation qu'il fait des informations du site</li>
        <li>Brokins ne peut être tenu responsable des dommages directs ou indirects résultant de l'utilisation du site</li>
        <li>Les liens vers des sites externes sont fournis à titre informatif, Brokins n'assume aucune responsabilité quant à leur contenu</li>
      </ul>
      
      <p class="important">Les offres d'assurance présentées sont soumises aux conditions générales des assureurs partenaires et peuvent évoluer.</p>
    </div>
  </section>

  <!-- Données personnelles -->
  <section class="page-section">
    <div class="highlight-box">
      <h2><i class="pi pi-user-shield"></i> Protection des données personnelles</h2>
      
      <p>La collecte et le traitement de vos données personnelles font l'objet d'une attention particulière.</p>
      
      <p>Pour en savoir plus sur la protection de vos données, consultez notre <strong><a [routerLink]="['/politique-confidentialite']">Politique de Confidentialité</a></strong>.</p>
      
      <div class="gdpr-info">
        <i class="pi pi-info-circle"></i>
        <div>
          <h4>Conformité RGPD</h4>
          <p>Brokins est en conformité avec le Règlement Général sur la Protection des Données (RGPD) et la loi Informatique et Libertés.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Droit applicable -->
  <section class="page-section">
    <h2><i class="pi pi-book"></i> Droit applicable et litiges</h2>
    
    <div class="legal-terms">
      <p><strong>Droit applicable :</strong> Les présentes mentions légales sont régies par le droit français.</p>
      
      <p><strong>Juridiction compétente :</strong> En cas de litige, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.</p>
      
      <p><strong>Médiation :</strong> En cas de litige relatif à nos services de courtage, vous pouvez saisir le Médiateur de l'Assurance :</p>
      
      <div class="mediator-info">
        <p>
          <strong>La Médiation de l'Assurance</strong><br>
          TSA 50110<br>
          75441 Paris Cedex 09<br>
          <strong>Site web :</strong> <a href="https://www.mediation-assurance.org" target="_blank" rel="noopener">www.mediation-assurance.org</a>
        </p>
      </div>
    </div>
  </section>

  <!-- CTA -->
  <section class="page-section">
    <div class="cta-box">
      <h3>Des questions sur nos services ?</h3>
      <p>Notre équipe est à votre disposition pour répondre à toutes vos interrogations</p>
      <button class="btn-cta" (click)="navigateToContact()">
        <i class="pi pi-comments"></i> Contactez-nous
      </button>
    </div>
  </section>

</app-page-layout>
